<template>
  <div class="modal_wrap system" :class="{ on: show }">
    <div class="modal_inner">
      <div class="modal">
        <div class="modal_head">
          <!--<h1 class="h1"></h1>-->
        </div>
        <div class="modal_con">
          <div class="modal_txt">
            <div class="center" v-html="data.msg"></div>
          </div>
        </div>
        <div class="form_wrap" v-if="data.checkbox">
          <div class="form_li">
            <div class="checkbox left">
              <!--'체크박스 오른쪽 정렬: right'-->
              <label
                ><input type="checkbox" v-model="doNotShowAgain" /><span
                  >다시 보지 않기</span
                ></label
              >
            </div>
          </div>
        </div>
        <div class="modal_btn">
          <div class="btn_wrap">
            <button
              class="btn"
              v-if="data.type === 'confirm'"
              @click="close(false)"
            >
              취소
            </button>
            <button class="btn" @click="close('confirm' == data.type)">
              확인
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import StorageFactory from '@common/lib/common/storage';

export default {
  props: {
    show: Boolean,
    data: {
      type: Object,
      default: () => {
        return {
          type: 'alert', // alert,confirm
          checkbox: false,
          msg: '',
        };
      },
    },
  },
  data() {
    return {
      doNotShowAgain: false,
    };
  },
  methods: {
    close(dataType) {
      if (this.data.checkbox) {
        this.setDoNotShowAgain(this.doNotShowAgain);
      }
      this.$emit('close', dataType);
    },
    setDoNotShowAgain(flag) {
      let storage = StorageFactory({
        storageType: 'localStorage',
      });
      storage.setItem('isDoNotShowAgain', flag);
    },
  },
};
</script>
